/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import format from 'date-fns/format';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import differenceInSeconds from 'date-fns/difference_in_seconds';
import Refresher from 'loracoms/Refresher';
import PanelToolbar from 'loracoms/PanelToolbar';
import TablePager from 'loracoms/TablePager';
import SearchInput from 'loracoms/SearchInput';
import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import GatewayList from '../GatewayList';
import styles from './styles.scss';

const isNew = time => differenceInSeconds(new Date(), time) < 10;

const propTypes = {
  intl: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
};

class Logs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
    this.handleChangeMark = this.handleChangeMark.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.mark = 0;
    this.q = null;
  }

  componentWillMount() {
    this.loadLogs();
  }

  loadLogs() {
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: `/lora/apps/${this.props.appId}/broadcastmsgs`,
      method: 'GET',
      query: {
        limit: 10,
        offset: this.mark,
        devaddr: this.q,
      },
    }).then((res) => {
      const { list, more, mark } = res;
      this.setState({ list, mark, more, status: 'success' });
      this.mark = res.mark;
    }).catch(() => {
      this.setState({ status: 'failure' });
    });
  }

  handleReload() {
    this.mark = 0;
    this.setState({ reset: new Date() });
    this.loadLogs();
  }

  handleSearch(e) {
    let search = e.target.value;
    search = search.replace(/[:-]/g, '');
    this.setState({
      search,
      reset: new Date(),
    });
    this.mark = 0;
    this.q = search.length > 0 ? search : null;
    this.loadLogs();
  }

  handleChangeMark(mark) {
    this.mark = mark;
    this.loadLogs();
  }

  handleShowGateway(gateways, failGateway) {
    this.setState({ gateways, failGateway, showModal: true });
  }

  render() {
    const {
      list,
      status = 'idle',
      mark = 0,
      more = false,
      reset = 0,
      search = '',
      gateways = [],
      failGateway = [],
      showModal = false,
    } = this.state;
    const rows = _.map(list, (l) => {
      let gwcontent;
      const total = l.success.length + l.fail.length;
      if (l.success.length <= 1 && total <= 1) {
        let gw;
        let link;
        if (l.success[0]) {
          gw = <span>{normalizeDevEUI(l.success[0])}</span>;
          link = l.success[0];
        } else if (l.fail[0]) {
          gw = <span className={styles.failgateway}>{normalizeDevEUI(l.fail[0])}</span>;
          link = l.fail[0];
        }
        gwcontent = (
          <Link to={`/gateway/detail/${link}`}>
            {gw}
          </Link>
        );
      } else if (total > 1) {
        gwcontent = (
          <Link
            onClick={() => this.handleShowGateway(l.success, l.fail)}
          >
            {normalizeDevEUI(l.success[0] || l.fail[0])} ...
          </Link>
        );
      } else {
        gwcontent = '';
      }
      return (
        <tr
          key={`${l.time}-${l.devaddr}`}
          className={isNew(l.time) ? styles.new : ''}
        >
          <td>{format(l.time, 'MM-DD HH:mm:ss')}</td>
          <td>
            {gwcontent}
          </td>
          <td>{l.devaddr.toLocaleLowerCase()}</td>
          <td>{l.fport}</td>
          <td>{l.encoding}</td>
          <td>{l.data}</td>
          <td>{l.fcntdown}</td>
        </tr>
      );
    });
    const tools = [(
      <SearchInput
        onChange={this.handleSearch}
        value={search}
        placeholder={this.intlMsg.msg('logs.search.placeholder')}
      />
    )];
    const header = (
      <div className="clerfix">
        {this.intlMsg.msg('logs.header')}
        <div className={`pull-right ${styles.gray}`}>
          <Refresher
            onReload={() => this.handleReload()}
            reloading={status === 'pending'}
          />
        </div>
      </div>
    );
    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
      >
        <PanelToolbar tools={tools} />
        <Table
          className="aisz-table-light"
          bordered
          responsive
        >
          <thead>
            <tr>
              <th>{this.intlMsg.msg('logs.time')}</th>
              <th>{this.intlMsg.msg('logs.gateway')}</th>
              <th>{this.intlMsg.msg('logs.address')}</th>
              <th>{this.intlMsg.msg('logs.port')}</th>
              <th>{this.intlMsg.msg('logs.encoding')}</th>
              <th>{this.intlMsg.msg('logs.data')}</th>
              <th>{this.intlMsg.msg('addrlist.fcntdown')}</th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </Table>
        <ShowIf if={list.length === 0}>
          <div className={styles.noData}>
            {this.intlMsg.msg('addrlist.nodata')}
          </div>
        </ShowIf>
        <div className="pull-right">
          <TablePager
            status={status}
            mark={mark}
            more={more}
            onPrev={this.handleChangeMark}
            onNext={this.handleChangeMark}
            reset={reset}
          />
        </div>
        <GatewayList
          showModal={showModal}
          list={gateways}
          onHide={() => this.setState({ showModal: false })}
          fail={failGateway}
        />
      </Panel>
    );
  }
}
Logs.propTypes = propTypes;

export default connect(
  null,
  null,
)(injectIntl(Logs));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/Logs/index.jsx